<div class="fc-signup-referral-status">
    <div class="fc-signup-referral-status-frame">
        <div class="fc-signup-referral-status-frame-body">
            <div class="fc-signup-referral-status-frame-body-header">
                {{ text.header | translate }}
            </div>
            <div class="fc-signup-referral-status-frame-body-description">
                <div class="fc-signup-referral-status-frame-body-description-title">
                    {{ text.description.line1 | translate }}
                </div>
                <div class="fc-signup-referral-status-frame-body-description-subtitle">
                    {{ text.description.line2 | translate }}
                </div>
            </div>

            <div class="fc-signup-referral-status-frame-body-action-signup">
                <button fcp-filled-button data-e2e-hook="signup-verified-email-resend-button" (click)="goToSignup()">
                    {{ 'SIGNUP.BUTTONS.REGISTER_NOW' | translate }} <i class="fal fa-arrow-right"></i>
                </button>
            </div>

            <div class="fc-signup-referral-status-frame-body-action-login">
                <div>{{ 'SIGNUP.ACCOUNT_EXISTS' | translate }}</div>
                <div (click)="goToLogin()" class="fc-signup-referral-status-frame-body-action-login-link">
                    <div class="fc-signup-referral-status-frame-body-action-login-link-icon">
                        <fcp-icon-svg
                            [icon]="iconNameMap.Login"
                            [color]="fcpIconSVGColors.Prominent"
                            [size]="fcpIconSVGSize.Small"
                        ></fcp-icon-svg>
                    </div>
                    <div class="fc-signup-referral-status-frame-body-action-login-link-text">
                        {{ 'SIGNIN_OK' | translate }}
                    </div>
                </div>
            </div>

            <div class="fc-signup-referral-status-frame-body-contact">
                <div>{{ 'SIGNUP.COMPLETED.SUCCESSFUL.HELP' | translate }}</div>
                <div class="fc-signup-referral-status-frame-body-contact-email">{{ supportEmail }}</div>
            </div>
        </div>
    </div>
</div>
